<!-- TEMPLATE -->
<template>
  <div class="wrapper">
    <dean-dialog
      :title="title"
      :small="true"
    >
      <slot name="load">

      </slot>
      <dean-notification :is-modal="true">

      </dean-notification>
      <p>{{text}}</p>
      <span slot="dean-dialog-button-group">
        <dean-button :danger="true" :dialog-button="true" @click.native="close()">Nee</dean-button>
        <dean-button :success="true" :dialog-button="true" @click.native="doYesClick()">Ja</dean-button>
      </span>
    </dean-dialog>
  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
  import Vue from 'vue';
  import {Component, Prop} from 'vue-property-decorator';
  import axios from 'axios';
  import {
    // SVG
    warningIcon,
    // COMPONENTS
    deanDialog,
    deanDialogButtonGroup,
  } from '@deanone/dean-components';
  import deanSelectFormRow from '@/components/deanComponents/deanSelectFormRow.vue';
  import deanButton from '@/components/deanComponents/deanButton.vue';
  import DeanNotification from '@/components/deanComponents/deanNotification.vue';
  import deanFormRow from '@/components/deanComponents/deanFormRow.vue';
  import {deanDialogBus} from '@/main';

  @Component({
    components: {
      warningIcon,
      DeanNotification,
      deanDialog,
      deanButton,
      deanFormRow,
      deanSelectFormRow,
      deanDialogButtonGroup,
    },
  })

  export default class DeleteUserDialog extends Vue {
    // DATA
    @Prop() public payloadData!: {
      [key: string]: string,
    };
    public data: {[key: string]: any} = {};
    public deleting: boolean = true;
    private deleteUrl: string = '';
    private undeleteUrl: string = '';

    // COMPUTED
    get title() {
      return this.deleting ? 'Gebruiker verwijderen?' : 'Gebruiker herstellen?';
    }

    get text() {
      let text = 'Weet u het zeker? Hiermee wordt gebruiker ' + this.fullName;
      text += this.deleting ? ' verwijderd.' : ' hersteld.';

      return text;
    }

    get fullName() {
      const name = this.payloadData.givenName ? this.payloadData.givenName + ' ' : '';

      return name + (this.payloadData.surnamePrefix ?
        this.payloadData.surnamePrefix + ' ' + this.payloadData.surname : this.payloadData.surname);
    }

    // METHODS
    public close() {
      deanDialogBus.$emit('close');
    }

    public doYesClick() {
      if (this.deleting) {
        this.deleteUser();
      } else {
        this.undeleteUser();
      }
    }

    public deleteUser() {
      this.$emit('setLoad', true);

      const requestData = {
        id: this.payloadData.id,
      };

      axios.post(this.deleteUrl, requestData)
        .then(
          (response) => {
            deanDialogBus.$emit('userStatusChange');

            this.close();
          },
          (error) => {
            this.$toast({
              icon: warningIcon,
              text: 'Gebruiker kan momenteel niet worden verwijderd, probeer het later opnieuw.',
              theme: 'warning',
            });
          },
        ).finally(() => {
        this.$emit('setLoad', false);
      });
    }

    public undeleteUser() {
      this.$emit('setLoad', true);

      const requestData = {
        id: this.payloadData.id,
      };

      axios.post(this.undeleteUrl, requestData)
        .then(
          (response) => {
            deanDialogBus.$emit('userStatusChange');

            this.close();
          },
          (error) => {
            this.$toast({
              icon: warningIcon,
              text: 'Gebruiker kan momenteel niet worden hersteld, probeer het later opnieuw.',
              theme: 'warning',
            });
          },
        ).finally(() => {
        this.$emit('setLoad', false);
      });
    }

    public setUrls(context: string) {
      if (context === 'partners') {
        this.deleteUrl = '/-/trade/api/partner.contact.delete';
        this.undeleteUrl = '/-/trade/api/partner.contact.undelete';
      } else if (context === 'customers') {
        this.deleteUrl = '/-/trade/api/customer.contact.delete';
        this.undeleteUrl = '/-/trade/api/customer.contact.undelete';
      } else if (context === 'profile') {
        this.deleteUrl = '/-/trade/api/person.contact.delete';
        this.undeleteUrl = '/-/trade/api/person.contact.undelete';
      }
    }

    public created() {
      this.deleting = (this.payloadData.state !== 'restoring');
      this.setUrls(this.payloadData.context);
    }

    public destroyed() {
      this.$emit('setLoad', false);
    }
  }
</script>

<!-- STYLE -->
<style lang="scss" scoped>
  // IMPORT
  @import '~@deanone/dean-components/src/scss/vars';
</style>